module.exports = "/static/media/lineto-circular-black.678b3387.eot";